import { LoadingScreen } from "@msuite/ui/loading-screen";
import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { useState } from "react";
import { client } from "@/hono";
import { SignUpInviteCreate } from "./sign-up-invite-create";
import { SignUpInviteExtend } from "./sign-up-invite-extend";

export function SignUpInvite() {
	/** State */
	const [isStillSignedIn] = useState(false);

	/** Hooks */
	const params = new URLSearchParams(document.location.search);
	const invitationId = params.get("invitationId");

	/** Query */
	const { data: invitationRequest, isLoading } = useQuery({
		queryKey: ["invitation", invitationId],
		queryFn: async () => {
			if (!invitationId) return null;
			const response = await client.organizations.invite[":invitationId"].$get({
				param: { invitationId },
			});
			const data = await responseHandler(response);
			return data;
		},
		staleTime: 1000,
	});

	if (isLoading || !invitationRequest?.invitation) return <LoadingScreen />;
	if (isStillSignedIn) return <p>YOU ARE STILL SIGNED IN</p>;
	if (invitationRequest?.invitation?.state === "accepted") {
		return <p>Invitation already accepted</p>;
	}

	if (invitationRequest?.user) {
		return <SignUpInviteExtend />;
	}
	return <SignUpInviteCreate invitation={invitationRequest?.invitation} />;
}
